import Api from "../apiService";

class CompanyUsersApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/company_users`,
      params,
      Api.authHeaders()
    );
  }

  counts(companyId) {
    return Api.getRequest(
      `companies/${companyId}/company_users/counts`,
      {},
      Api.authHeaders()
    );
  }

  show(companyId, userId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/company_users/${userId}`,
      params,
      Api.authHeaders()
    );
  }

  create(companyId, userData) {
    return Api.postRequest(
      `companies/${companyId}/company_users`,
      userData,
      Api.authHeaders()
    );
  }

  update(companyId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/company_users/${id}`,
      data,
      Api.authHeaders()
    );
  }

  enable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/company_users/${id}/enable`,
      {},
      Api.authHeaders()
    );
  }

  disable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/company_users/${id}/disable`,
      {},
      Api.authHeaders()
    );
  }

  searchCandidates(companyId, search) {
    return Api.getRequest(
      `companies/${companyId}/company_users/search_candidates`,
      { search },
      Api.authHeaders()
    );
  }

  inviteCandidate(companyId, data) {
    return Api.postRequest(
      `companies/${companyId}/company_users/invite_candidate`,
      data,
      Api.authHeaders()
    );
  }

  inviteNewUser(companyId, data) {
    return Api.postRequest(
      `companies/${companyId}/company_users/invite_new_user`,
      data,
      Api.authHeaders()
    );
  }

  generatePassword(companyId) {
    return Api.postRequest(
      `companies/${companyId}/company_users/generate_password`,
      {},
      Api.authHeaders()
    );
  }

  changePermissionRole(companyId, id, permissionRoleId) {
    return Api.patchRequest(
      `companies/${companyId}/company_users/${id}/change_permission_role`,
      { permission_role_id: permissionRoleId },
      Api.authHeaders()
    );
  }
}

export default new CompanyUsersApi();
